import React from 'react';
import classnames from 'classnames';
import './Switch.css';

export interface ISwitchProps {
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: (e: any) => void;
  readOnly?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  id?: string;
  color?: 'primary-1' | 'hot-pink';
}

const sizeClassMapping = {
  sm: 'w-8 h-4',
  md: 'w-12 h-6',
  lg: 'w-16 h-6',
};

const Switch: React.FC<React.PropsWithChildren<ISwitchProps>> = ({
  name,
  value,
  readOnly,
  checked,
  onChange,
  size = 'md',
  className,
  id,
  color = 'hot-pink',
}) => {
  return (
    <label className="cursor-pointer Switch">
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        readOnly={readOnly || !onChange}
        onChange={onChange}
        className="w-0 h-0 opacity-0 appearance-none"
        id={id}
      />
      <div
        className={classnames(
          'inline-flex items-stretch overflow-hidden bg-gray-400 rounded-full shadow-inner Switch-toggle bg-opacity-10',
          sizeClassMapping[size],
          className,
          color
        )}
      >
        <div className="w-1/2 bg-white rounded-full shadow" />
      </div>
    </label>
  );
};
export { Switch };
